import { observer } from 'mobx-react-lite';

import { Table } from '@/components/table';
import { getColumns } from './setup';

export const Farmers = observer(({ waybill }: { waybill: cyrian.api.waybills.Waybill }) => {
  const columns = getColumns();

  return <Table rowKey="id" columns={columns} dataSource={waybill?.farmerDetails || []} scroll={{ x: 950 }} />;
});
